<footer class="content-container" [ngClass]="{'d-none': shouldHide, 'd-flex': !shouldHide}">
  <div class="clr-row ml-0">
    <div class="clr-col-12 clr-col-md-4 text-xs-center text-md-left mb-3 mb-md-0">
      <a href="https://www.facebook.com/funbible.net/"
         target="_blank"
         rel="noopener noreferrer"
         class="mr-3"
      ><fa-icon [icon]="['fab', 'facebook']"></fa-icon></a>
      <a href="https://www.instagram.com/funbible_net/"
         target="_blank"
         rel="noopener noreferrer"
         class="mr-3"
      ><fa-icon [icon]="['fab', 'instagram']"></fa-icon></a>
      <a href="https://www.youtube.com/channel/UC3Cgn1AQOI2wMN3fRhV91OA"
         target="_blank"
         rel="noopener noreferrer"
         class="mr-3"
      ><fa-icon [icon]="['fab', 'youtube']"></fa-icon></a>
    </div>
    <div class="clr-col-12 clr-col-md-4 text-xs-center mb-3 mb-md-0">
      <a *ngFor="let section of sections"
         [routerLink]="['/'+section.slug]"
         class="nav-link p-0 mb-2"
      >
        <span class="nav-text">{{section.title}}</span>
      </a>
    </div>
    <div class="clr-col-12 clr-col-md-4 text-xs-center text-md-right">
      <div class="ml-3 text-center  d-inline-block">Fun Bible © Toate drepturile rezervate</div>
    </div>
  </div>
</footer>